module.exports = __webpack_public_path__ + "static/media/top-img_9@2x.dc1ce3f2.jpg";